import { FormatFunction } from '../../shared/types/field-types';
const numberRegEx = /[\d,]+/g;
export const parseNumbers = (input: string) => (input.match(numberRegEx) || []).join('');

/*
  Does not work with negative numbers.
  Does not add thousandseperators
 */
export const formatFloat = (maxFractionDigits = 2): FormatFunction => {
    const f = (input: string) => {
        const r = new RegExp(numberRegEx);
        const t = r.test(input);
        if (t) {
            // filter away illigal chars
            input = parseNumbers(input);

            const index = input.indexOf(',');
            if (index > -1) {
                // remove all commas except the first
                input = input.substring(0, index + 1) + input.substring(index + 1).replace(/,/g, '');
                // trunc string after maxFractionDigits
                input = input.substring(0, index + maxFractionDigits + 1);
            }
            return input;
        } else {
            return '';
        }
    };

    return f;
};
